import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import StatsSection from '../components/StatsSection';
import ProblemSection from '../components/ProblemSection';
import HowItWorksSection from '../components/HowItWorksSection';
import MissionSection from '../components/MissionSection';
import ScotlandComparisonSection from '../components/ScotlandComparisonSection';
import AgentLogosSection from '../components/AgentLogosSection';
import WhyStabilitySection from '../components/WhyStabilitySection';
import TestimonialsSection from '../components/TestimonialsSection';
import FAQSection from '../components/FAQSection';
import CTASection from '../components/CTASection';
import FooterReveal from '../components/FooterReveal';
import ScrollReveal from '../hooks/useScrollReveal';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="relative z-10 bg-black">
        <HeroSection />
        
        <ScrollReveal threshold={0.2}>
          <StatsSection />
        </ScrollReveal>
        
        <ScrollReveal delay={100} threshold={0.2}>
          <ProblemSection />
        </ScrollReveal>
        
        <ScrollReveal delay={150} threshold={0.2}>
          <HowItWorksSection />
        </ScrollReveal>
        
        {/* Mission Section with Scroll Text Effect - No ScrollReveal wrapper */}
        <MissionSection />
        
        <ScrollReveal delay={150} threshold={0.2}>
          <ScotlandComparisonSection />
        </ScrollReveal>
        
        <ScrollReveal delay={100} threshold={0.2}>
          <AgentLogosSection />
        </ScrollReveal>
        
        <ScrollReveal delay={150} threshold={0.2}>
          <WhyStabilitySection />
        </ScrollReveal>
        
        <ScrollReveal delay={100} threshold={0.2}>
          <TestimonialsSection />
        </ScrollReveal>
        
        <ScrollReveal delay={150} threshold={0.2}>
          <FAQSection />
        </ScrollReveal>
        
        <ScrollReveal delay={100} threshold={0.2}>
          <CTASection />
        </ScrollReveal>
      </main>
      <FooterReveal />
    </div>
  );
};

export default HomePage;
